import { Component, Inject, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { DiscountType } from '../../../models/coupons/discount-type-model'
import { DiscountTypeService } from '../../../services/coupons/discount-type.service';
import { UtilitiesService } from '../../../services/shared/utilities.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../../services/role/role-permission.service';

@Component({
    selector: 'app-discount-type-list',
    templateUrl: './discount-type-list.component.html',
    styleUrls: ['./discount-type-list.component.scss']
})
/** discount-type-list component*/
export class DiscountTypeListComponent {
  public discountTypeList: DiscountType[];
  searchKeyword: string;
  isActive: string;
  discountNature: number;
  //Filter items from grid
  filteredItems: any[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  /** discount-type-list ctor */
  constructor(private readonly discountTypeService: DiscountTypeService, private readonly utilitiesService: UtilitiesService,
    public toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("discountype").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
          this.getDiscountTypes();
          this.GetRowsPerPageList();
          this.toastr.setRootViewContainerRef(vcr);
          this.isActive = "";
            this.discountNature = 0;
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  } 

  deleteDiscountType(id) {
    if (confirm("Are you sure to delete this Discount type?")) {
      this.discountTypeService.deleteDiscountType(id).subscribe(
        response => {
          if (response) {
            this.toastr.success('Discount Type has been Deleted.', 'Success');
            setTimeout(() => {
              this.getDiscountTypes();
            }, 2000);
          }
          else {
            this.toastr.error('Error occurred. Oop!', 'Success');
          }
        }
      )
    }
  }
  getDiscountTypes() {
    this.discountTypeService.getDiscountTypes().subscribe(
      data => {
        this.discountTypeList = data;
        this.filteredItems = data;
      }
    )
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  // Search the Grid
  OnFilterChange() {
    this.filteredItems = this.discountTypeList;

    if (this.searchKeyword != "" && this.searchKeyword != null) {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.filteredItems, this.searchKeyword);
    }
    if (this.isActive == "true") {
      this.filteredItems = this.filteredItems.filter(s => s.isActive == true);

    }
    else if (this.isActive == "false") {
      this.filteredItems = this.filteredItems.filter(s => s.isActive == false);
    }
    if (this.discountNature >0) {
      this.filteredItems = this.filteredItems.filter(s => s.discountNatureType == this.discountNature);

    }
  }
}



// WEBPACK FOOTER //
// ./src/app/coupons/discount-type/discount-type-list/discount-type-list.component.ts